import { Routes } from '@angular/router';

/**
 * Every route is lazy, so the initial bundle only carries the app shell. The
 * layout chunk is shared by all children and each page is fetched on first
 * navigation to it.
 */
export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./modules/layout/layout.component').then((m) => m.LayoutComponent),
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        title: 'Dashboard',
        loadComponent: () =>
          import('./modules/dashboard/dashboard.component').then((m) => m.DashboardComponent)
      },
      {
        path: 'projects',
        title: 'Projects',
        loadComponent: () =>
          import('./modules/projects/project-list.component').then((m) => m.ProjectListComponent)
      },
      {
        // A componentless parent: the children render straight into the layout's
        // outlet, so `scans` groups its pages without an extra wrapper chunk.
        path: 'scans',
        children: [
          {
            path: '',
            title: 'Scans',
            loadComponent: () =>
              import('./modules/scans/scans.component').then((m) => m.ScansComponent)
          },
          {
            path: 'new',
            title: 'New Scan',
            loadComponent: () =>
              import('./modules/scans/new-scan/new-scan.component').then((m) => m.NewScanComponent)
          },
          {
            path: 'findings',
            title: 'Findings',
            loadComponent: () =>
              import('./modules/scans/findings/findings.component').then((m) => m.FindingsComponent)
          }
        ]
      },
      {
        path: 'vulnerabilities',
        children: [
          {
            path: '',
            title: 'Vulnerabilities',
            loadComponent: () =>
              import('./modules/vulnerabilities/vulnerabilities.component').then(
                (m) => m.VulnerabilitiesComponent
              )
          },
          {
            // `withComponentInputBinding()` is enabled, so `:id` arrives as the
            // detail component's `id` input - no ActivatedRoute plumbing needed.
            path: ':id',
            title: 'Vulnerability Details',
            loadComponent: () =>
              import(
                './modules/vulnerabilities/vulnerability-detail/vulnerability-detail.component'
              ).then((m) => m.VulnerabilityDetailComponent)
          }
        ]
      },
      {
        path: 'products',
        title: 'Products',
        loadComponent: () =>
          import('./modules/products/products.component').then((m) => m.ProductsComponent)
      },
      {
        path: 'schedule',
        title: 'Scheduled Scans',
        loadComponent: () =>
          import('./modules/schedule/schedule.component').then((m) => m.ScheduleComponent)
      },
      {
        path: 'assets',
        title: 'Assets',
        loadComponent: () =>
          import('./modules/assets/assets.component').then((m) => m.AssetsComponent)
      },
      {
        path: 'reports',
        title: 'Reports',
        loadComponent: () =>
          import('./modules/reports/reports.component').then((m) => m.ReportsComponent)
      },
      {
        path: 'settings',
        title: 'Settings',
        loadComponent: () =>
          import('./modules/settings/settings.component').then((m) => m.SettingsComponent)
      }
    ]
  },
  { path: '**', redirectTo: '' }
];
